/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines-per-function */
// Libraries
import { FormElems, Alert, ConditionalComponent } from '../';
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    fetchEntityRequest,
    updateUserRequest,
    updateAdminUserRequest,
    updateUserReset,
    createUserReset,
    fetchSystemUsersRequest,
} from '../../containers/UserManagement/redux/userManagement.actions';
import {
    getUserStatus,
    getUserLevel,
    getStatusMap,
    nameValueOptions,
} from '../../utils/helperMethods';
import { USER_MANAGEMENT_MSG } from '../../utils/constants/toastMessages';
import {
    ENTITY_TYPE,
    EXCLUDED_ENTITY_USER_LEVELS,
    MAX_USER_FETCH_COUNT_USER_MANAGEMENT,
    USER_LEVEL_ENUM,
} from '../../utils/constants/commonValues';
import validate from './validator';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';

// Components

// Actions

// Constants

// Validator

// Styles
import './userEditViewForm.scss';

const UserEditViewForm = props => {
    const {
        closePopup,
        handleSubmit,
        actionType,
        actions,
        data,
        handleOpenActionPopup,
        userManagementData,
        formData,
        change,
        initialValues,
    } = props;
    const {
        userRoles,
        entityList,
        updateUser,
        systemUserList,
    } = userManagementData;

    const entityType =
        formData &&
        formData.values &&
        formData.values.userLevel &&
        formData.values.userLevel.toUpperCase();
    const status =
        formData && formData.values && getStatusMap(formData.values.userStatus);
    const uLevel = formData && formData.values && formData.values.uLevel;

    useEffect(() => {
        if (entityType && entityType !== 'ADMIN') {
            actions.fetchEntityRequest({
                entityType,
            });
        }

        if (
            entityType &&
            uLevel &&
            EXCLUDED_ENTITY_USER_LEVELS.includes(entityType)
        ) {
            if (uLevel !== 'L3') {
                actions.fetchSystemUsersRequest({
                    page: 1,
                    resultPerPage: MAX_USER_FETCH_COUNT_USER_MANAGEMENT,
                    userFilter: {
                        level: uLevel === 'L2' ? 'L3' : 'L2',
                    },
                });
            }
        }
    }, [entityType, actions, uLevel]);

    const onCancel = event => {
        event.preventDefault();
        closePopup();
    };

    const onEdit = event => {
        event.preventDefault();
        handleOpenActionPopup('edit');
    };

    useEffect(() => {
        if (updateUser.isSuccess) {
            closePopup(true);
            toast.info(USER_MANAGEMENT_MSG.USER_UPDATE);
        }
    }, [closePopup, updateUser.isSuccess]);

    function handleFormSubmit(values) {
        const entityValue = entityList.find(
            entity => entity.value === values.entityId
        );

        const entityName = entityValue && entityValue.name;

        const request = {
            ...values,
            entityName,
        };

        if (
            !request.entityName &&
            EXCLUDED_ENTITY_USER_LEVELS.includes(entityType)
        ) {
            request.entityName = request.entityId;
        }

        if (values.userLevel && values.userLevel === 'ADMIN') {
            actions.updateAdminUserRequest(request);
        } else {
            actions.updateUserRequest(request);
        }
    }

    useEffect(() => {
        // reset error message on unmount
        return () => {
            actions.updateUserReset();
            actions.createUserReset();
        };
    }, [actions]);

    const resetForm = () => {
        actions.updateUserReset();
    };

    const isFormReadOnly = actionType === 'view';
    const userLevelOption = getUserLevel(entityType);
    const userStatusOption = getUserStatus(data);

    return (
        <form
            className="create-user-form user-view-edit"
            onChange={resetForm}
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            {isFormReadOnly ? (
                <>
                    <div className="form-field status-section">
                        <p className="label">Status</p>
                        <div
                            className={`status ${data.userStatus &&
                                data.userStatus.split(' ').join('')}`}
                        >
                            {data.userStatus}
                        </div>
                        <div className="lastupdate-status">
                            {data.lastUpdatedByName && (
                                <>
                                    Last Edit :{' '}
                                    <strong>{data.lastUpdatedByName}, </strong>
                                    {moment(data.lastUpdatedDate, 'DD/MM/YYYY')
                                        .calendar()
                                        .indexOf('Today') >= 0
                                        ? 'Today'
                                        : moment(
                                              data.lastUpdatedDate,
                                              'DD/MM/YYYY'
                                          )
                                              .calendar()
                                              .indexOf('Yesterday') >= 0
                                        ? 'Yesterday'
                                        : data.lastUpdatedDate}
                                </>
                            )}
                            {!data.lastUpdatedByName && (
                                <>
                                    Created By :
                                    <strong> {data.userCreatedByName}, </strong>
                                    {moment(data.userCreatedDate, 'DD/MM/YYYY')
                                        .calendar()
                                        .indexOf('Today') >= 0
                                        ? 'Today'
                                        : moment(
                                              data.userCreatedDate,
                                              'DD/MM/YYYY'
                                          )
                                              .calendar()
                                              .indexOf('Yesterday') >= 0
                                        ? 'Yesterday'
                                        : data.userCreatedDate}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="form-section">
                        <div
                            className="form-field"
                            style={{ marginRight: '25px' }}
                        >
                            <p className="label">Email ID</p>
                            <p className="user-text email">{data.email}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">Role</p>
                            <p className="user-text">{data.userRoleName}</p>
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">User Type</p>
                            <p className="user-text">{data.userLevel}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">User Level</p>
                            <p className="user-text">{data.level}</p>
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">Supervisor's Email</p>
                            <p className="user-text">{data.supervisor}</p>
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">{data.userLevel}</p>
                            <div
                                className={`form-field ${
                                    isFormReadOnly ? 'disabled' : null
                                }`}
                            >
                                {data.entityName}
                            </div>
                        </div>
                    </div>
                    <div className="form-section comment-box">
                        <p className="label">Comment</p>
                        <p className="comment-text">{data.comment || '-'}</p>
                    </div>
                </>
            ) : (
                <>
                    <div className="form-section">
                        <div className="form-field disabled">
                            <p className="label">Email ID</p>
                            {/* <Field
                                name="email"
                                type="text"
                                disabled={true}
                                component={FormElems.Input}
                                placeholder="Enter Email ID"
                            /> */}
                            <p className="user-text email">{data.email}</p>
                        </div>
                    </div>
                    <div className="form-section">
                        <div
                            className="form-field"
                            style={{ marginRight: '25px' }}
                        >
                            <p className="label">Name</p>
                            <Field
                                name="name"
                                type="text"
                                component={FormElems.Input}
                                placeholder="Enter Name"
                            />
                        </div>
                        <div className="form-field">
                            <p className="label">Role</p>
                            <Field
                                name="userRole"
                                data={userRoles.list}
                                label="Select Role"
                                labelField="name"
                                valueField="value"
                                component={FormElems.Select}
                                placeholder="Enter Name"
                            />
                        </div>
                    </div>
                    <div className="form-field status-section">
                        <p className="label">Status</p>
                        <Field
                            name="userStatus"
                            options={userStatusOption}
                            defaultSelected={status}
                            valueField="value"
                            labelField="name"
                            component={FormElems.Radio}
                            isDisabled={isFormReadOnly}
                            placeholder="Enter Role Name"
                        />

                        <Field
                            wrapperClass="comment-input"
                            name="remarks"
                            type="textarea"
                            isDisabled={isFormReadOnly}
                            component={FormElems.TextArea}
                            placeholder="Enter Comment "
                        />
                    </div>
                    <div className="form-section">
                        <div className="form-field user-level">
                            <p className="label">Select User Type</p>
                            <Field
                                name="userLevel"
                                wrapperClass="buttonMode"
                                defaultSelected={entityType}
                                options={userLevelOption}
                                valueField="value"
                                labelField="name"
                                component={FormElems.Radio}
                                isDisabled={isFormReadOnly}
                            />
                        </div>
                    </div>
                    <ConditionalComponent
                        isVisible={
                            entityType &&
                            EXCLUDED_ENTITY_USER_LEVELS.includes(entityType)
                        }
                    >
                        <div className="form-section">
                            <div className="form-field user-level">
                                <p className="label">Select User Level</p>
                                <Field
                                    name="uLevel"
                                    wrapperClass="buttonMode"
                                    options={nameValueOptions(
                                        Object.keys(USER_LEVEL_ENUM)
                                    )}
                                    onChange={() => {
                                        change('supervisor', '');
                                    }}
                                    valueField="value"
                                    labelField="name"
                                    component={FormElems.Radio}
                                />
                            </div>
                        </div>
                        <ConditionalComponent
                            isVisible={
                                formData &&
                                formData.values &&
                                formData.values.uLevel &&
                                formData.values.uLevel !== 'L3'
                            }
                        >
                            <div className="form-section">
                                <div className="form-field">
                                    <p className="label">Select Supervisor</p>
                                    <Field
                                        name="supervisor"
                                        data={systemUserList.filter(
                                            item =>
                                                item.value !==
                                                formData.values.userId
                                        )}
                                        label={`Select Supervisor`}
                                        labelField="name"
                                        valueField="value"
                                        component={FormElems.Select}
                                        placeholder="Enter Email ID"
                                    />
                                </div>
                            </div>
                        </ConditionalComponent>
                    </ConditionalComponent>
                    {entityType && entityType !== 'ADMIN' ? (
                        <div className="form-section">
                            <div className="form-field">
                                <p className="label">
                                    {ENTITY_TYPE[entityType]}
                                </p>
                                <Field
                                    name="entityId"
                                    data={entityList}
                                    label={`Select ${ENTITY_TYPE[entityType]}`}
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    placeholder="Enter Email ID"
                                />
                            </div>
                        </div>
                    ) : null}
                </>
            )}
            {updateUser.message ? <Alert>{updateUser.message}</Alert> : null}
            <div className="form-section action">
                <FormElems.Button
                    buttonType="secondary"
                    text="CANCEL"
                    handleClick={onCancel}
                    customClass="cancel-btn"
                />
                {isFormReadOnly ? (
                    <FormElems.Button
                        buttonType="primary"
                        text="EDIT"
                        handleClick={onEdit}
                        customClass="edit-btn"
                    />
                ) : (
                    <FormElems.Button buttonType="primary" text="UPDATE" />
                )}
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, userManagementData, form }) => ({
    auth,
    userManagementData,
    formData: form['user-view-edit'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            fetchEntityRequest,
            updateUserRequest,
            updateAdminUserRequest,
            updateUserReset,
            createUserReset,
            fetchSystemUsersRequest,
            change,
        },
        dispatch
    ),
});

UserEditViewForm.propTypes = {
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    actionType: PropTypes.string,
    data: PropTypes.object,
    handleOpenActionPopup: PropTypes.func,
    userManagementData: PropTypes.object,
    actions: PropTypes.object,
    formData: PropTypes.object,
    change: PropTypes.func,
};

export default compose(
    reduxForm({
        form: 'user-view-edit',
        enableReinitialize: true,
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(UserEditViewForm);
